import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { FiFileText } from "react-icons/fi";
import { getType } from "../../actions/studensts";
import UNAUTHORIZED from "../UNAUTHORIZED";
import StudentList from "../StudentList";

export default function Invoice() {
  const dispatch = useDispatch();
  const location = useLocation();
  const studentType = useLocation().pathname.split("/")[3];
  const { students } = useSelector((state) => state.students);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const count = useSelector((state) => state.students.count);
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;

  useEffect(() => {
    dispatch({ type: "CLEAR" });
    if (!hasSearched) return;
    const state = convertType(studentType);
    const timeOutId = setTimeout(
      () => dispatch(getType("invoice", state, search)),
      500
    );
    return () => clearTimeout(timeOutId);
  }, [location, search, dispatch, studentType, hasSearched]);

  useEffect(() => {
    setHasSearched(false);
  }, [location]);

  useEffect(() => {
    if (students) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [students]);

  const pageTitle =
    studentType === "new"
      ? "New in Invoice"
      : studentType === "another_invoice"
      ? "Another Invoice"
      : studentType === "wait"
      ? "Invoice Wait"
      : "Invoice";

  return (
    <div>
      {!["admin", "auditor", "agent"].includes(user) ? (
        <UNAUTHORIZED />
      ) : (
        <div className="min-h-screen px-4 sm:px-8 py-6">
          {/* Page Header */}
          <div className="mb-8 flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-indigo-600/20 border border-indigo-500/30 flex items-center justify-center shrink-0">
              <FiFileText className="text-indigo-400 text-xl" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white tracking-tight">{pageTitle}</h1>
              <p className="text-slate-400 text-sm mt-0.5">Manage invoice state students</p>
            </div>
          </div>

          {/* Content */}
          <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 shadow">
            <StudentList
              setSearch={(val) => {
                setSearch(val);
                setHasSearched(true);
              }}
              students={students}
              search={search}
              loading={loading}
              count={count}
            />
          </div>
        </div>
      )}
    </div>
  );
}

function convertType(studentType) {
  switch (studentType) {
    case "new":
      return "invoice";
    case "another_invoice":
      return "another_invoice";
    case "wait":
      return "invoice_wait";
    default:
      return "invoice";
  }
}
